import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Divider } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import MessageContentForm from "../../common/MessageContentForm";
import BasicModalWithHeader from "../../global/Modal/BasicModalWithHeader";
import { COMPANY_STATUS, COMPANY_STATUS_TEXT } from "../../helpers/constant/coreConstant";
import { showErrorToaster } from "../../helpers/utils/toaster";
import useBoolean from "../../hooks/useBoolean";
import adminAuthService from "../../services/adminAuth.service";
import { updateCompanyStatus } from "../../state/companyList/companyListSlice";
// import PaymentModal from "./PaymentModal";
import CreditConfigModal from "./CreditConfigModal";
import CompanyCreditBalance from "./CompanyCreditBalance";
import LinkedinSlotsModal from "./LinkedinSlotsModal";
import LinkedinManualAdjustModal from "./LinkedinManualAdjustModal";
import EditCompanyForm from "./EditCompanyForm";
import BasicDrawer from "../../global/Drawer/BasicDrawer";

const ITEM_HEIGHT = 48;

const CompanyMenuAction = ({ companyInfo }) => {
  const dispatch = useDispatch();
  const { id, status = 0, ownerInfo } = companyInfo || {};
  const targetStatus = status === COMPANY_STATUS.ACTIVE ? COMPANY_STATUS.INACTIVE : COMPANY_STATUS.ACTIVE;

  const { value: openModal, setFalse: onCloseModal } = useBoolean(false);
  // const { value: openPaymentModal, setTrue: onOpenPaymentModal, setFalse: onClosePaymentModal } = useBoolean(false);
  const { value: openEditCompanyModal, setTrue: onOpenEditCompanyModal, setFalse: onCloseEditCompanyModal } = useBoolean(false);
  const { value: openCreditConfigModal, setTrue: onOpenCreditConfigModal, setFalse: onCloseCreditConfigModal } = useBoolean(false);
  const { value: openCompanyCreditBalanceModal, setTrue: onOpenCompanyCreditBalanceModal, setFalse: onCloseCompanyCreditBalanceModal } = useBoolean(false);
  const { value: openLinkedinSlotsModal, setTrue: onOpenLinkedinSlotsModal, setFalse: onCloseLinkedinSlotsModal } = useBoolean(false);
  const { value: openLinkedinManualAdjustModal, setTrue: onOpenLinkedinManualAdjustModal, setFalse: onCloseLinkedinManualAdjustModal } = useBoolean(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = (status) => {
    dispatch(updateCompanyStatus({ companyId: id, status: status }));
    handleMenuClose();
  };

  // const hanldeClosePaymentModal = () => {
  //   onClosePaymentModal();
  //   handleMenuClose();
  // };

  const handleAdminLogin = () => {
    if (ownerInfo?.id) {
      adminAuthService
        .forceLoginEmployerAccount({ id: ownerInfo.id })
        .then((response) => {
          handleMenuClose();

          if (response.status) {
            var PREFIX = "employer_info";
            window.open(response.data.redirectUri, PREFIX + JSON.stringify({ token: response.data.token }));
          } else {
            showErrorToaster(response.message);
          }
        })
        .catch((err) => console.log("Error:: ", err));
    }
  };

  const open = Boolean(anchorEl);
  return (
    <>
      <IconButton aria-label="more" id="long-button" aria-controls={open ? "long-menu" : undefined} aria-expanded={open ? "true" : undefined} aria-haspopup="true" onClick={handleMenuClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 5.5,
          },
        }}
      >
        <MenuItem onClick={handleAdminLogin}>Force Login</MenuItem>
        {/* <MenuItem onClick={onOpenPaymentModal}>Payment</MenuItem> */}
        <MenuItem
          onClick={() => {
            onOpenCreditConfigModal();
            handleMenuClose();
          }}
        >
          Credit Config
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenCompanyCreditBalanceModal();
            handleMenuClose();
          }}
        >
          Credit Balance
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenLinkedinSlotsModal();
            handleMenuClose();
          }}
        >
          LinkedIn Promotion
        </MenuItem>
        <MenuItem
          onClick={() => {
            onOpenLinkedinManualAdjustModal();
            handleMenuClose();
          }}
        >
          LinkedIn Promotion Manual Adjust
        </MenuItem>

        <Divider />
        <MenuItem
          onClick={() => {
            onOpenEditCompanyModal();
            handleMenuClose();
          }}
        >
          Edit Company
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => handleStatusChange(targetStatus)}>{COMPANY_STATUS_TEXT[targetStatus]}</MenuItem>
        <Divider />
        {companyInfo.status === COMPANY_STATUS.PENDING && (
          <MenuItem sx={{ backgroundColor: "rgba(255, 0, 0, 0.07)", color: "red" }} onClick={() => handleStatusChange(COMPANY_STATUS.INACTIVE)}>
            Block
          </MenuItem>
        )}
      </Menu>
      {/* <BasicModalWithHeader title={"Select Payment method"} open={openPaymentModal} onClose={hanldeClosePaymentModal}>
        <PaymentModal close={hanldeClosePaymentModal} companyInfo={companyInfo} />
      </BasicModalWithHeader> */}
      <BasicModalWithHeader title={`Edit Company for ${companyInfo?.name}`} open={openEditCompanyModal} onClose={onCloseEditCompanyModal}>
        <EditCompanyForm onClose={onCloseEditCompanyModal} companyInfo={companyInfo} />
      </BasicModalWithHeader>
      <BasicModalWithHeader title={`Credit Configuration for ${companyInfo?.name}`} open={openCreditConfigModal} onClose={onCloseCreditConfigModal} autoScroll={true}>
        <CreditConfigModal onClose={onCloseCreditConfigModal} companyInfo={companyInfo} />
      </BasicModalWithHeader>
      <BasicModalWithHeader title={`Update Credit Balance for ${companyInfo?.name}`} open={openCompanyCreditBalanceModal} onClose={onCloseCompanyCreditBalanceModal}>
        <CompanyCreditBalance onClose={onCloseCompanyCreditBalanceModal} companyInfo={companyInfo} />
      </BasicModalWithHeader>
      <BasicDrawer width={700} title={`LinkedIn Promotion for ${companyInfo?.name}`} open={openLinkedinSlotsModal} onClose={onCloseLinkedinSlotsModal}>
        <LinkedinSlotsModal onClose={onCloseLinkedinSlotsModal} companyInfo={companyInfo} />
      </BasicDrawer>
      <BasicModalWithHeader title={`LinkedIn Manual Adjust for ${companyInfo?.name}`} open={openLinkedinManualAdjustModal} onClose={onCloseLinkedinManualAdjustModal}>
        <LinkedinManualAdjustModal onClose={onCloseLinkedinManualAdjustModal} companyInfo={companyInfo} />
      </BasicModalWithHeader>
      <BasicModalWithHeader title={"Message Content"} open={openModal} onClose={onCloseModal}>
        <MessageContentForm close={onCloseModal} />
      </BasicModalWithHeader>
    </>
  );
};

export default CompanyMenuAction;
